import { createApiAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as constants from './types';

// get organization
export const getOrganization = createApiAction(
  constants.GET_ORGANIZATION,
  (payload, meta, dispatch, getState) => api.getOrganization(
    getState().user.username,
  ),
);
